// src/app/app.routes.ts
import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // Login (standalone)
  {
    path: 'login',
    loadComponent: () => import('../app/pages/login/login.page').then(m => m.LoginPage)
  },

  // Home sebagai tab root (ion-tabs) — children memuat component standalone
  {
    path: 'home',
    loadComponent: () => import('../app/pages/home/home.page').then(m => m.HomePage),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('../app/pages/dashboard/dashboard.page').then(m => m.DashboardPage)
      },
      {
        path: 'kasir',
        loadComponent: () => import('../app/pages/kasir/kasir.page').then(m => m.KasirPage)
      },
      {
        path: 'produk',
        loadComponent: () => import('../app/pages/produk/produk.page').then(m => m.ProdukPage)
      },
      {
        path: 'laporan',
        loadComponent: () => import('../app/pages/laporan/laporan.page').then(m => m.LaporanPage)
      },
      {
        path: 'kulak',
        loadComponent: () => import('./pages/kulak/kulak.page').then( m => m.KulakPage)
      },
      // default child for /home
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },

  // Search / other pages
  {
    path: 'search',
    loadComponent: () => import('../app/pages/search/search.page').then(m => m.SearchPage)
  },

  // fallback
  { path: '**', redirectTo: 'login' }
];
